import { ClientNavSearchInput } from '@susu/headless-commerce/features/navigation/components/NavSearchInput'
import classNames from 'classnames'
import styles from './NavSearchInput.module.scss'

export type NavSearchInputProps = {
  className?: string
}

export const NavSearchInput = ({ className }: NavSearchInputProps) => {
  const searchInputClass = classNames(styles['nav__search-input'], className)

  return <ClientNavSearchInput className={searchInputClass} />
}
